import { app } from '../../../../app';
import { Controller } from './account-password-update.controller';

app.component('accountPasswordUpdate', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./account-password-update.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-password-update/account-password-update.component.js